import { PropsWithChildren } from 'react';
import logo from '~/assets/img/logo-unboared.png';

import styles from './NavbarContainer.module.css';

export function NavbarContainer({ children }: PropsWithChildren) {
    return (
        <div className={styles.navbar}>
            <img className={styles.logo} src={logo} alt="unboared logo" />
            <div className={styles.menu}>{children}</div>
        </div>
    );
}
